const strize = require('../strize')

module.exports = {
  title: 'CER ADMIN',
  imgs: {
    root: '../../imagesCER'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: true
  },
  bucket: {
    player: {
      bucket: strize(''),
      region: strize('')
    },
    editor: {
      bucket: strize(''),
      region: strize(''),
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#c73c41',
    bgSideBar: '#232733',
    ActionMail: '#dadada'
  },
  layouts: {
  }
}
